import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export type AnalyticsEmptyVariant = 'no-mentions' | 'no-competitors';

// Фаза 4: shared "nothing to show" state for all 7 Analytics screens - distinct from, and does
// not touch, the per-KPI "no mentions in this period" handling (noMentionsLabel()/
// SampleSizeNoteComponent) for a single empty value. 'no-mentions': zero mentions anywhere in the
// selected period/filters - every screen can hit this. 'no-competitors': the client has no
// Competitor-kind tag configured at all - shown only on the Brands screen, the one screen whose
// entire content is a company-vs-competitor comparison; every other screen's own data stays
// meaningful with just the Company tag.
@Component({
	selector: 'app-analytics-empty-state',
	standalone: true,
	imports: [MatIconModule, TranslateModule],
	templateUrl: './analytics-empty-state.component.html',
})
export class AnalyticsEmptyStateComponent {
	@Input({ required: true }) variant!: AnalyticsEmptyVariant;
}
